"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CartSubMenu = require("./CartSubMenu");

var _CartSubMenu2 = _interopRequireDefault(_CartSubMenu);

var _HeaderContext = require("../HeaderContext");

var _HeaderContext2 = _interopRequireDefault(_HeaderContext);

require("./CartMenu.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CartMenu = function CartMenu(props) {
  var children = props.children,
      callbacks = props.callbacks,
      campaignId = props.campaignId,
      isMobile = props.isMobile,
      data = props.data,
      expandProductDetails = props.expandProductDetails;
  var products = data.products,
      total = data.total,
      cartText = data.cartText,
      variantCount = data.variantCount,
      credit = data.credit,
      appliedCredit = data.appliedCredit,
      remainingCredit = data.remainingCredit,
      appliedPurchaseCredit = data.appliedPurchaseCredit,
      appliedAddonCredit = data.appliedAddonCredit,
      subtotal = data.subtotal,
      fees = data.fees;
  return _react2.default.createElement(_HeaderContext2.default.Consumer, null, function (context) {
    var expandedMenu = context.expandedMenu,
        setExpandedMenu = context.setExpandedMenu;
    return _react2.default.createElement("div", {
      className: "cart-menu-btn pad-8 pos-r z-1000"
    }, _react2.default.createElement("button", {
      onClick: function onClick() {
        return setExpandedMenu({
          id: isMobile ? "mobile-cart" : "cart"
        });
      },
      className: "fff-header-cart-button pad-0 cur-pointer pos-r"
    }, _react2.default.createElement("i", {
      className: "fal fa-shopping-cart"
    }), !!variantCount && _react2.default.createElement("div", {
      className: "pos-a fff-cart-item-count fs-12 mar-a"
    }, variantCount)), expandedMenu && expandedMenu.id === "cart" && _react2.default.createElement(_CartSubMenu2.default, {
      id: "cart-menu",
      right: true,
      callbacks: callbacks,
      products: products,
      cartText: cartText,
      credit: credit,
      appliedCredit: appliedCredit,
      remainingCredit: remainingCredit,
      campaignId: campaignId,
      subtotal: subtotal,
      fees: fees,
      total: total,
      children: children,
      isMobile: isMobile,
      appliedAddonCredit: appliedAddonCredit,
      appliedPurchaseCredit: appliedPurchaseCredit,
      expandProductDetails: expandProductDetails
    }));
  });
};

exports.default = CartMenu;